<template>
    <div class="basic-map-popover">
        <p
            class="h6"
            v-test:title
        >
            {{ title }}
        </p>

        <address v-test:address>
            {{ address }}
        </address>

        <slot />

        <markdown-content
            v-if="text"
            class="text"
            :content="text"
            v-test:text
        />
    </div>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent.vue';

    export default {
        name: 'basic-map-popover',

        components: { MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            text: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .basic-map-popover {
        width: 100%;
        font-size: rem(12px);
        overflow: hidden;
    }

    address {
        margin-bottom: 5px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .h6 {
        margin-bottom: 0;
        padding-right: 20px;
    }

    .text {
        margin-top: 1em;

        ::v-deep {
            p:last-child,
            ul:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>
